<template>
  <div>
    <rhcn-card-v2 :title="$t('message.refuse.klarnaRebutDrawer.shipping.title')">
      <template #body>
        <el-form :disabled="disabled" :rules="rules(formData.goodType == '1')" :model="formData" ref="shippingForm">
          <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.shipping.goodType')" prop="goodType">
              <el-select v-model="formData.goodType">
                <el-option
                  v-for="item in goodTypeDict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
          </el-form-item>

          <!-- 为实物商品时 -->
          <template v-if="formData.goodType == '1'">
            <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.shipping.trackingNumber')" prop="trackingNumber">
              <el-input maxlength="50" v-model="formData.trackingNumber" :placeholder="$t('message.refuse.klarnaRebutDrawer.shipping.trackingNumberPlaceHolder')"></el-input>
            </el-form-item>
            <div style="display: flex;justify-content: space-between;gap: 16px;">
              <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.shipping.firstName')" prop="firstName">
                <el-input maxlength="20" v-model="formData.firstName"></el-input>
              </el-form-item>
              <el-form-item style="flex: 1;" :label="$t('message.refuse.klarnaRebutDrawer.shipping.lastName')" prop="lastName">
                <el-input maxlength="20" v-model="formData.lastName"></el-input>
              </el-form-item>
            </div>
            <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.customer.phone')" prop="phoneNumber">
              <el-input maxlength="20" v-model="formData.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$t('message.refuse.klarnaRebutDrawer.shipping.addressTitle')" prop="addressTitle">
          </el-form-item>
            <AddressForm :disabled="disabled" ref="shippingAddressFormRef" :data="formData.shippingAddress" @update:data="formData.shippingAddress = $event"/>
          </template>

        </el-form>
      </template>
    </rhcn-card-v2>
  </div>
</template>

<script>
import RhcnCardV2 from '@/componentsV2/base-cmps/card/index.vue';
import GlobalData from '@/utils/global/index';
import { initSelectedData } from '@/utils/tools/constant';
import AddressForm from '@/views/transaction/refuse-manage/klarna-rebut/components/form/addressForm/index.vue';

import { rules } from './rules';
export default {
  components: {
    RhcnCardV2,
    AddressForm,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 商品类型字典
      goodTypeDict: [],
    };
  },
  mounted() {
    this.getGoodType();
  },
  methods: {
    rules,
    async validate() {
      if (this.formData.goodType === '1') {
        return await this.$refs.shippingForm.validate() && await this.$refs.shippingAddressFormRef.validate();
      }
      return await this.$refs.shippingForm.validate();
    },
    clearValidate() {
      this.$refs.shippingForm.clearValidate();
      if (this.$refs.shippingAddressFormRef && this.$refs.shippingAddressFormRef.clearValidate) {
        this.$refs.shippingAddressFormRef.clearValidate();
      }
    },
    async getGoodType() {
      const dict = await GlobalData.getDictList(['CHARGEBACK_APPEAL_GOODS_TYPE']);
      this.goodTypeDict = initSelectedData(dict.CHARGEBACK_APPEAL_GOODS_TYPE, 'description', 'value', false);
    },
  },
  computed: {
    formData: {
      get() {
        return this.data;
      },
      set(newValue) {
        this.$emit('update:data', newValue);
      },
    },
  },

};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

:deep(.el-input__count) {
  background-color: transparent !important;
  color: #8D98AF !important;
}

:deep(.el-descriptions__body) {
  background-color: transparent !important;
}
</style>
